"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class QuickPanelModule {
}
exports.QuickPanelModule = QuickPanelModule;
